import React, { useState, useEffect } from "react";
import { insights as mockInsights } from "../mock";
import ArticleCard from "../components/ArticleCard";
import { getInsights } from "../api";
import { useI18n } from "../i18n/I18nContext";

const Insights = () => {
  const { t, localize } = useI18n();
  const [rawInsights, setInsights] = useState(mockInsights);
  const [active, setActive] = useState("All");

  useEffect(() => {
    getInsights()
      .then((data) => {
        if (Array.isArray(data) && data.length) setInsights(data);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const insights = localize("insights", rawInsights);
  const categories = ["All", ...Array.from(new Set(insights.map((i) => i.category)))];
  const filtered =
    active === "All" ? insights : insights.filter((i) => i.category === active);
  const [featured] = insights;

  return (
    <div>
      {/* Page header */}
      <section className="bg-[#0a2540] text-white py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <span className="text-sm font-700 uppercase tracking-widest text-[#5eb0f5]">
            {t("insights")}
          </span>
          <h1 className="font-display font-800 text-4xl md:text-6xl mt-3 max-w-3xl leading-[1.05]">
            {t("insightsTitle")}
          </h1>
          <p className="mt-6 text-slate-300 text-lg max-w-2xl">
            {t("insightsBody")}
          </p>
        </div>
      </section>

      {/* Featured */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative overflow-hidden rounded-lg aspect-[16/11] bg-slate-100 hover-zoom group">
            <img src={featured.image} alt={featured.title} className="w-full h-full object-cover" />
          </div>
          <div>
            <span className="text-xs font-700 uppercase tracking-wider text-[#0a6ed1]">
              {featured.category} · {t("featuredLabel")}
            </span>
            <h2 className="font-display font-800 text-3xl md:text-4xl text-[#0a2540] mt-3 leading-tight">
              {featured.title}
            </h2>
            <p className="mt-5 text-slate-500 text-lg leading-relaxed">
              {featured.excerpt}
            </p>
            <div className="mt-6 text-sm text-slate-400">
              {featured.date} · {featured.readTime}
            </div>
          </div>
        </div>
      </section>

      {/* Filter + grid */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-8 pb-24">
        <div className="flex flex-wrap gap-3 mb-12 border-b border-slate-200 pb-6">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`px-5 py-2 rounded-full text-sm font-600 transition-colors ${
                active === c
                  ? "bg-[#0a2540] text-white"
                  : "bg-slate-100 text-[#0a2540] hover:bg-slate-200"
              }`}
            >
              {c === "All" ? t("filterAll") : c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
          {filtered.map((i) => (
            <ArticleCard key={i.id} item={i} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Insights;
